<template>
  <p :class="`question ${design}`">{{ text }}</p>
</template>
<script>
export default {
  props: {
    text: { type: String, required: true },
    design: { type: String },
  },
};
</script>
<style scoped>
.question {
  font-size: 1.6em;
  font-weight: 300;
  color: #AAAAAB;
  margin-bottom: 25px;
}
.question.two {
  font-weight: 400;
  color: #AAAAAB;
}
</style>